import {FTUETrainerTextProps} from '@skillz/ui';
import {
  ImageSourcePropType,
  ImageStyle,
  TextProps,
  TextStyle,
  ViewStyle,
  Animated,
} from 'react-native';

import {_m} from 'INTL';
import ClientPropertyConstants from 'ClientPropertyConstants';
import AssetHelper from 'AssetHelper';
import {
  BUBBLE_STYLE,
  BUBBLE_TEXT_CONTAINER_STYLE,
  BUBBLE_TEXT_PROPS,
  BUBBLE_TEXT_STYLE,
  CONTAINER_STYLE,
  CONTENT_CONTAINER_STYLE,
  OVERLAY_GRADIENT_PROPS,
} from './GameOperationsTrainerBase.config';
import {LinearGradientProps} from 'react-native-linear-gradient';
import SKZConstants from 'SKZConstants';

/**
 * This class holds all base properties & behavior for the Game Operations Tutorial Scenes.
 * Subclasses should override properties to display the desired text, image facing and overlay behavior.
 */
export default class GameOperationsTrainerBase implements FTUETrainerTextProps {
  // trainer image
  trainerImage: {
    source: ImageSourcePropType;
    width: number;
    height: number;
    style?: ImageStyle | undefined;
  };

  // text bubble
  arrowSide: 'left' | 'right';
  bubbleAsset: {uri: string};
  bubbleOffset: number;
  bubbleAnimation?: Animated.TimingAnimationConfig | undefined;
  bubbleStyle?: ViewStyle | undefined;
  text: string;
  textStyle?: TextStyle | undefined;
  textProps?: Partial<TextProps> | undefined;
  textContainerStyle?: ViewStyle | undefined;

  // custom styles
  containerStyle?: ViewStyle | undefined;
  contentContainerStyle?: ViewStyle | undefined;

  // overlay
  overlayVisible: boolean;
  overlayGradientProps?: LinearGradientProps | undefined;

  constructor(trainerAssetKey: SKZConstants.ETrainerAssetKey) {
    // trainer image
    const trainerImageUri = ClientPropertyConstants.getGameOperationsTutorialImageURL();
    const defaultTutorialTrainerImageUri = AssetHelper.pathForAssetNamed(
      'tutorial_avatar_contained_face_right.png',
      false
    );

    this.trainerImage = {
      source: {uri: trainerImageUri || defaultTutorialTrainerImageUri},
      width: 106,
      height: 130,
      style: {
        marginTop: 50,
        // flips the image if the trainer is facing left
        transform: [{scaleX: trainerAssetKey === SKZConstants.ETrainerAssetKey.FaceLeft ? -1 : 1}],
      },
    };

    // text bubble
    this.arrowSide = trainerAssetKey === SKZConstants.ETrainerAssetKey.FaceLeft ? 'right' : 'left';
    this.bubbleAsset = {uri: AssetHelper.pathForAssetNamed('image_text_bubble.png', false)};
    this.bubbleOffset = 84;
    this.text = '';
    this.textProps = BUBBLE_TEXT_PROPS;

    // custom styles
    this.containerStyle = CONTAINER_STYLE;
    this.contentContainerStyle = CONTENT_CONTAINER_STYLE;
    this.bubbleStyle = BUBBLE_STYLE;
    this.textStyle = BUBBLE_TEXT_STYLE;
    this.textContainerStyle = BUBBLE_TEXT_CONTAINER_STYLE;

    // overlay
    this.overlayVisible = true;
    this.overlayGradientProps = OVERLAY_GRADIENT_PROPS;
  }
}
